import { useContext } from 'react'
import UserContext from '../../../helper/userContext'
import formatDateLocale from '../../../helper/formatDateLocale'

export default (props) => {
  const { currentLanguage } = useContext(UserContext)
  const { value, formatStr = 'P' } = props
  return value ? formatDateLocale(currentLanguage, value, formatStr) : ''
}
